import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { ContactCard } from "@/components/site/ContactCard";
import { ContactForm } from "@/components/site/ContactForm";

export default function Contact() {
  return (
    <>
      <Seo title="Contact Us | Easy Handyman Services Oxfordshire"
        description="Call or WhatsApp 07836 207134 or email Easy Handyman Services. Property maintenance across Oxfordshire, Monday to Saturday 8:00 AM – 6:00 PM." />
      <PageHero testId="contact-hero" eyebrow="Contact" lines={["Let's talk about", "your home."]}
        intro="Questions, bookings or a quick price check – we're happy to help. Open Monday to Saturday, 8:00 AM to 6:00 PM." />
      <section className="bg-[var(--grey)] py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 grid gap-8 lg:grid-cols-12">
          <Reveal className="lg:col-span-5 space-y-6">
            <ContactCard />
            <div className="rounded-[1.75rem] bg-white p-6 sm:p-8 flex items-start gap-4" data-testid="contact-service-area">
              <MapPin className="mt-1 h-6 w-6 shrink-0 text-[var(--green)]" />
              <div>
                <h2 className="font-display text-xl font-bold text-[var(--navy)]">Service area</h2>
                <p className="mt-1 text-[var(--body)]">We serve customers throughout Oxfordshire, UK.</p>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-7">
            <div className="rounded-[1.75rem] bg-white p-6 sm:p-10">
              <h2 className="font-display text-2xl sm:text-3xl font-bold text-[var(--navy)]">Send us a message</h2>
              <p className="mt-2 mb-8 text-[var(--body)]">
                Looking for a price? The <Link to="/quote" className="font-semibold text-[var(--green)] underline" data-testid="contact-quote-link">free quote form <ArrowUpRight className="inline h-4 w-4" /></Link> lets you add photos too.
              </p>
              <ContactForm />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
